import { styled } from '@stitches/configed';
import { Divider, Layout, Tooltip } from 'antd';
import { ReactNode, useContext } from 'react';
import { RouterType } from '..';
import { Logo } from '../..';
import CloseLeftNavIcon from '../../Common/Icons/CloseLeftNavIcon';
import RouteContext from '../RouteContext';
import { Profile } from '../UserInfo';
import MenuAdminBoard from './MenuAdminBoard';
import MenuMerchant from './MenuMerchant';
import { ButtonClose, LogoContainer, SidebarFooter } from './Sidebar.styled';

const SidebarStyled = styled(Layout.Sider, {
  // overflow: "auto",
  height: '100vh',
  position: 'absolute !important',
  // position: 'sticky !important',
  zIndex: 999,
  top: 0,
  left: 0,
  '@xs': {
    // zIndex: 0, // comment for fixed PageContainer.footer
    position: 'sticky !important',
  },
});

const WrapFooterItem = styled('div', {
  borderRadius: '100px',
  display: 'flex',
  gap: 8,
  alignItems: 'center',
  cursor: 'pointer',
  marginBottom: 8,

  fontSize: '16px',

  '&:hover': {
    color: '#ffff',
    background: '#FAFBFF33',

    '&.collapsed': {
      background: 'none',
    },

    '& > .icon': {
      color: '#000',
      background: '#ffff',
    },
  },

  '& > .icon': {
    width: 38,
    height: 38,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '100%',
  },
});

type Props = {
  currentUser?: Profile;
  routes: RouterType[];
  showableRoutes?: string[];
  collapsed: boolean;
  hidden: boolean;
  toggleCollapsed: () => void;
  customItemSidebar?: ReactNode;
  typeApp: 'merchant' | 'admin';
  countState?: Record<string, any>;
};
export default function Sidebar({
  currentUser,
  collapsed,
  hidden,
  toggleCollapsed,
  routes,
  showableRoutes,
  customItemSidebar,
  typeApp,
  countState
}: Props) {
  const { isMobile } = useContext(RouteContext);

  return (
    <>
      <SidebarStyled
        collapsible
        trigger={null}
        collapsed={collapsed}
        hidden={hidden}
        width={isMobile ? '100%' : 324}
        collapsedWidth={isMobile ? 0 : undefined}
        breakpoint="lg"
        onCollapse={() => {
          toggleCollapsed();
        }}
      >
        <LogoContainer onClick={() => isMobile && toggleCollapsed()}>
          <ButtonClose onClick={toggleCollapsed} isMobile={isMobile} />
          <div style={{ margin: 'auto' }}>
            <Logo small={collapsed} />
          </div>
        </LogoContainer>

        {typeApp === 'merchant' && (
          <MenuMerchant
            currentUser={currentUser}
            routes={routes}
            showableRoutes={showableRoutes}
            collapsed={collapsed}
            toggleCollapsed={toggleCollapsed}
            customItemSidebar={customItemSidebar}
            countState={countState}
          />
        )}

        {typeApp === 'admin' && (
          <MenuAdminBoard
            currentUser={currentUser}
            routes={routes}
            showableRoutes={showableRoutes}
            collapsed={collapsed}
            toggleCollapsed={toggleCollapsed}
            customItemSidebar={customItemSidebar}
          />
        )}

        <Divider
          style={{
            borderColor: '#999',
            margin: '8px 0',
          }}
        />

        <SidebarFooter>
          {!collapsed ? (
            <>
              <WrapFooterItem onClick={toggleCollapsed}>
                <div className="icon">
                  <CloseLeftNavIcon />
                </div>
                Đóng menu
              </WrapFooterItem>
              <div style={{ color: '#fff' }}>YOUGO Merchant Portal</div>

              <div style={{ color: '#fff' }}>© 2024 All Rights Reserved</div>
            </>
          ) : (
            <>
              <WrapFooterItem onClick={toggleCollapsed} className="collapsed">
                <Tooltip placement="right" title={collapsed ? 'Mở menu' : ''}>
                  <div className="icon collapsed">
                    <CloseLeftNavIcon />
                  </div>
                </Tooltip>
              </WrapFooterItem>
            </>
          )}
        </SidebarFooter>
      </SidebarStyled>
    </>
  );
}
